import React from 'react';

const RouterMonitoringFilterBar = ({ filters, onRefresh }) => (
  <div className="rounded-xl border border-slate-800 bg-slate-900/70 p-3">
    <div className="grid gap-2 md:grid-cols-5">
      <input
        value={filters.search}
        onChange={(e) => filters.setSearch(e.target.value)}
        placeholder="Cari router / NAS / IP"
        className="h-10 rounded-lg border border-slate-700 bg-slate-950 px-3 text-sm text-slate-100 outline-none focus:border-cyan-400"
      />
      <select
        value={filters.statusFilter}
        onChange={(e) => filters.setStatusFilter(e.target.value)}
        className="h-10 rounded-lg border border-slate-700 bg-slate-950 px-3 text-sm text-slate-100 outline-none focus:border-cyan-400"
      >
        <option value="all">Semua Status</option>
        <option value="online">Online</option>
        <option value="offline">Offline</option>
      </select>
      <select
        value={filters.vendorFilter}
        onChange={(e) => filters.setVendorFilter(e.target.value)}
        className="h-10 rounded-lg border border-slate-700 bg-slate-950 px-3 text-sm text-slate-100 outline-none focus:border-cyan-400"
      >
        <option value="all">Semua Vendor</option>
        <option value="mikrotik">MikroTik</option>
        <option value="snmp">SNMP</option>
        <option value="generic">Generic</option>
      </select>
      <select
        value={filters.range}
        onChange={(e) => filters.setRange(e.target.value)}
        className="h-10 rounded-lg border border-slate-700 bg-slate-950 px-3 text-sm text-slate-100 outline-none focus:border-cyan-400"
      >
        <option value="5m">Range 5 Menit</option>
        <option value="1h">Range 1 Jam</option>
        <option value="24h">Range 24 Jam</option>
      </select>
      <button
        type="button"
        onClick={onRefresh}
        className="h-10 rounded-lg border border-cyan-400/40 bg-cyan-500/10 px-3 text-sm font-semibold text-cyan-200 hover:bg-cyan-500/20"
      >
        Refresh
      </button>
    </div>
  </div>
);

export default RouterMonitoringFilterBar;
